import { render, staticRenderFns } from "./HuddersfieldCity.vue?vue&type=template&id=1fb62a92&scoped=true&"
import script from "./HuddersfieldCity.vue?vue&type=script&lang=js&"
export * from "./HuddersfieldCity.vue?vue&type=script&lang=js&"
import style0 from "./HuddersfieldCity.vue?vue&type=style&index=0&id=1fb62a92&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb62a92",
  null
  
)

export default component.exports